import { ActionContext, ActionTree, GetterTree } from "vuex";

const initialState: any = {
  values: {
    fontSizeLevel: 2
  }
};

const actions: ActionTree<any, any> = {
  setFontSizeLevel({ commit }: ActionContext<any, any>, payload: any): void {
    commit("setFontSizeLevel", payload);
  }
};

const mutations = {
  setFontSizeLevel(state: any, payload: any) {
    Object.assign(state, { values: { fontSizeLevel: payload } });
  }
};

const getters: GetterTree<any, any> = {
  fontSizeLevel(state: any) {
    return state.values.fontSizeLevel;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
